const initialState = {
  reportList: [],
  reportDetail: null,
  loading: true
}

export default initialState
